module.exports = __webpack_public_path__ + "media/images/textSelectionSample__dropdown@2x-22bd035131d5b85343cb3073bf0bbbf1.png";